module.exports = __webpack_public_path__ + "img/projectManagement.c115c071.jpg";